import {
  computed,
  h,
  onUnmounted,
  shallowRef,
  type Component,
  type ComputedRef,
  type Ref,
  type VNode,
} from 'vue'

type UseModalsReturn = {
  currentModal: Ref<VNode | null>
  openModal: (component: Component, props?: Record<string, unknown>) => void
  closeModal: () => void
  isOpen: ComputedRef<boolean>
}

const currentModal = shallowRef<VNode | null>(null)

function openModal(
  component: Component,
  props: Record<string, unknown> = {},
): void {
  currentModal.value = h(component, {
    ...props,
    onClose: closeModal,
  })
}

function closeModal(): void {
  currentModal.value = null
}

const isOpen = computed(() => currentModal.value !== null)

export function useModals(): UseModalsReturn {
  return { currentModal, openModal, closeModal, isOpen }
}

/** Clears module-level modal state when the hosting view unmounts. */
export function useModalsHost(): void {
  onUnmounted(closeModal)
}
